import { CheckCircle } from "lucide-react";

const RXTBusinessBenefits = () => {
  const benefits = [
    "All-in-one solution — video, audio, control, and power in one device",
    "Choose the right model: D for control + RTSP, DV for full AVoIP integration",
    "4-inch for compact installations, 6-inch for larger display real estate",
    "SmartSpeak™ beamforming and WordGate™ camera tracking on all models",
    "DV models: 100W USB-C charging eliminates separate power adapters",
    "WordGate™ AI camera tracking eliminates false triggers from non-speech noises",
    "RTSP stream support on all models for camera monitoring without AVoIP",
    "Seamless integration with existing Dante™/AES67 audio networks",
    "Enhanced meeting security through proximity-based speaker design",
    "Free Core Studio programming tools reduce deployment costs"
  ];

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Business Benefits</h2>
      <div className="bg-card rounded-lg p-8 border shadow-sm">
        <div className="grid gap-4 md:grid-cols-2">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-muted-foreground">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RXTBusinessBenefits;
